import { PortableText } from '@portabletext/react'

import { isNilOrEmpty } from 'ramdasauce'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text } from 'components/atoms'

export const RichText = ({ data, className }) => {
  const classes = useStyles()
  const textWrapper = cn({
    [classes.articleText]: isNilOrEmpty(className),
    [className]: !isNilOrEmpty(className),
  })
  const hyperLinkClasses = cn({
    [classes.links]: true,
  })

  const portableTextComponents = {
    block: {
      h1: ({ children }) => {
        return (
          <div className={textWrapper}>
            <Text tag="h3" size="header1">
              {children}
            </Text>
            <br />
          </div>
        )
      },
      h2: ({ children }) => {
        return (
          <div className={textWrapper}>
            <Text tag="h4" size="header2">
              {children}
            </Text>
            <br />
          </div>
        )
      },
      normal: ({ children }) => {
        return (
          <div className={textWrapper}>
            {children}
            <br />
          </div>
        )
      },
    },
    marks: {
      link: ({ children, value }) => {
        const target = (value?.href || '').startsWith('http')
          ? '_blank'
          : undefined
        return (
          <a
            href={value?.href}
            className={hyperLinkClasses}
            target={target}
            rel={target === '_blank' && 'noindex nofollow'}
          >
            {children}
          </a>
        )
      },
    },
  }
  return (
    data && <PortableText value={data} components={portableTextComponents} />
  )
}
